import { render, staticRenderFns } from "./DemoCarDetail.vue?vue&type=template&id=53a8dece"
import script from "./DemoCarDetail.vue?vue&type=script&lang=js"
export * from "./DemoCarDetail.vue?vue&type=script&lang=js"
import style0 from "./DemoCarDetail.vue?vue&type=style&index=0&id=53a8dece&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports